<template>
  <!-- <LoginFrm /> -->
  <router-view />
  <div
    v-if="swUpdateAvailable"
    class="sw-update-banner"
    role="status"
    aria-live="polite"
  >
    <span class="sw-update-banner__text">
      <strong class="sw-update-banner__title">Update available</strong>
      A new version of the app is ready. Reload to use the latest version.
    </span>
    <div class="sw-update-banner__actions">
      <button
        type="button"
        class="sw-update-banner__btn sw-update-banner__btn--primary"
        @click="reloadForSwUpdate"
      >
        Reload
      </button>
      <button
        type="button"
        class="sw-update-banner__btn"
        @click="dismissSwUpdate"
      >
        Dismiss
      </button>
    </div>
  </div>
</template>

<script>
// import LoginFrm from "./auth/login.vue";

export default {
  name: "App",
  components: {
    // LoginFrm,
  },
  data() {
    return {
      swUpdateAvailable: false,
      swRegistration: null,
      swWaitingStateHandler: null,
    };
  },
  mounted() {
    window.addEventListener("swUpdated", this.onSwUpdated);
  },
  beforeUnmount() {
    window.removeEventListener("swUpdated", this.onSwUpdated);
    this.teardownSwWaitingListener();
  },
  methods: {
    onSwUpdated(event) {
      this.swRegistration = event.detail;
      this.swUpdateAvailable = true;
    },
    dismissSwUpdate() {
      this.swUpdateAvailable = false;
      this.teardownSwWaitingListener();
    },
    teardownSwWaitingListener() {
      const registration = this.swRegistration;
      const handler = this.swWaitingStateHandler;
      if (handler && registration && registration.waiting) {
        registration.waiting.removeEventListener("statechange", handler);
      }
      this.swWaitingStateHandler = null;
    },
    reloadForSwUpdate() {
      const registration = this.swRegistration;
      if (!registration || !registration.waiting) {
        window.location.reload();
        return;
      }
      this.teardownSwWaitingListener();
      const waiting = registration.waiting;
      const onStateChange = (e) => {
        const sw = e.target;
        if (sw && sw.state === "activated") {
          waiting.removeEventListener("statechange", onStateChange);
          this.swWaitingStateHandler = null;
          window.location.reload();
        }
      };
      this.swWaitingStateHandler = onStateChange;
      waiting.addEventListener("statechange", onStateChange);
      waiting.postMessage({ type: "SKIP_WAITING" });
    },
  },
};
</script>

<style scoped>
@keyframes sw-banner-enter {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.sw-update-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 20px;
  padding-top: max(14px, env(safe-area-inset-top, 0px));
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  color: #f8fafc;
  border-bottom: 4px solid #f59e0b;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.35),
    0 0 0 1px rgba(245, 158, 11, 0.35);
  font-size: 15px;
  line-height: 1.45;
  animation: sw-banner-enter 0.35s ease-out;
}

.sw-update-banner__text {
  flex: 1 1 auto;
  min-width: 220px;
}

.sw-update-banner__title {
  display: block;
  margin-bottom: 4px;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fef3c7;
}

.sw-update-banner__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.sw-update-banner__btn {
  padding: 10px 18px;
  border-radius: 8px;
  border: 2px solid rgba(248, 250, 252, 0.45);
  background: rgba(15, 23, 42, 0.6);
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.sw-update-banner__btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(248, 250, 252, 0.75);
}

.sw-update-banner__btn:active {
  transform: scale(0.98);
}

.sw-update-banner__btn--primary {
  border-color: #f59e0b;
  background: #f59e0b;
  color: #0f172a;
}

.sw-update-banner__btn--primary:hover {
  background: #fbbf24;
  border-color: #fbbf24;
}
</style>
